import {cx} from "emotion";
import * as React from "react";

import "./thumbnails.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

export const Thumbnails = ({images}) => cs(
    ["hovered", (_, next) => UseState({next})],
    ({hovered}) => (
        <div className="thumbnails thumbnails-9op">
            {images?.map((img, i) => (
                <div
                    key={i}
                    className={cx("img", {selected: img.selected, hovered: hovered.value === img})}
                    style={{backgroundImage: `url('${img.src}')`}}
                    onMouseEnter={() => hovered.onChange(img)}
                    onMouseLeave={() => hovered.onChange(null)}
                    onClick={() => img?.onSelect()}
                    xd-qa-type={"icon"}
                    xd-qa-name={"Back " + (i+1)}
                >
                    {img.selected && (
                        <div className="check">
                            <i className="fa fa-check"/>
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
);
